<template>
  <div class="spl-report-detail-header">
    <form-button style="grid-column: 1" @onClick="handleEditReport">
      Edit
    </form-button>
    <div style="grid-column: 2" />
    <form-button
      style="grid-column: 3"
      data-cy="report-detail-header-excel"
      @onClick="handleDownloadExcel">
      Excel
    </form-button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Helpers from '@/helpers.vue'
import { round } from 'lodash'
export default {
  mixins: [Helpers],

  computed: {
    ...mapState('report', ['loadedReport', 'reportResult'])
  },
  methods: {
    handleEditReport () {
      // Goes into the edit page of the report
      this.$router.push('/report-edit/' + this.loadedReport.Report_ID)
    },
    handleDownloadExcel () {
      var excelList = {
        Columns: [],
        Rows: []
      }
      var selectedFields = this.loadedReport.Report_Layout
      // Loop through the columns and add them to excel object
      for (let i = 0; i < selectedFields.length; i++) {
        const field = selectedFields[i]
        excelList.Columns.push({ ID: field.Name, Header: field.Label, Type: this.getColumnType(field.Format) })
      }

      const results = this.reportResult
      // add the values
      for (let i = 0; i < results.length; i++) {
        var rowValues = { Value: [] }
        const result = results[i]
        for (let j = 0; j < selectedFields.length; j++) {
          const field = selectedFields[j]
          rowValues.Value.push(this.formatField(result[field.Name], field.Format))
        }
        excelList.Rows.push(rowValues)
      }
      // Call the excel download helper
      this.getexcelDownload(excelList, 'SPLIT_Report.xlsx')
    },
    // Special formatting for fields
    formatField (field, type) {
      if (type === 'Number.2') {
        return round(field, 2).toFixed(2)
      } else if (type === 'Number.3') {
        return round(field, 3).toFixed(3)
      } else if (type === 'Date') {
        return this.formatDate(field, false, 'YYYY-MM-DD')
      } else if (type === 'Timestamp') {
        return this.formatDate(field, true, 'YYYY-MM-DD HH:mm')
      }
      // empty fields will be removed
      if (field == null) {
        return ''
      }
      return field
    },
    getColumnType (fieldType) {
      // Converts the formats into excel compatible ones
      // "Number", "DateTime", "Text", "Boolean"
      if (fieldType) {
        switch (fieldType) {
          case 'Number':
          case 'Number.2':
          case 'Number.3':
            return 'Number'

          case 'Boolean' :
            return 'Boolean'

          case 'Date':
          case 'Timestamp':
            return 'DateTime'

          case 'String':
          default: {
            return 'Text'
          }
        }
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
  @import '../../../variables.scss';
  .spl-report-detail-header {
    padding: 0 70px;
    display: grid;
    grid-template-columns: 100px auto 100px;
    margin-bottom: 15px;
    .spl-button {
      margin: 0;
    }
  }
</style>
